import { UploadDropzone } from '@atlas/ui-components'
import { notification } from '@/notifications/notification-store'

const MAX_BYTES = 50 * 1024 * 1024

/** A PNG, JPG or PDF drop zone that reports each file over 50MB and passes on only the rest. */
export function CappedUploadDropzone({ label, onFiles }: { label: string; onFiles: (files: File[]) => void }) {
	const onDrop = (list: File[]) => {
		for (const file of list.filter((f) => f.size > MAX_BYTES)) notification.error(`${file.name} is over 50MB.`)
		onFiles(list.filter((file) => file.size <= MAX_BYTES))
	}
	return (
		<UploadDropzone
			label={label}
			prompt="Drag & Drop your files here or browse"
			hint="PNG, JPG or PDF (Multiple files, up to 50MB each)"
			accept="image/png,image/jpeg,application/pdf"
			onFiles={onDrop}
		/>
	)
}
